declare var swal: any;
import { Component, OnInit, Input, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { ActorService } from '../../../../services/actor.service';
import { ActorProfileRequest, ActorProfileController, ActorImageController, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, GuardianInfoController, GuardianInfoRequest, SaveCustomerMessageRequest, CustomerMessageRequest, CustomerMessageController, OTFormDetailByReportCodeController, OTFormDetailByReportCodeRequest, SectionData, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, SingleWellInseminationByCycleController, SingleWellInseminationByCycleRequest, IvfCycleInseminationLogByCycleWithDOCController, IvfCycleInseminationLogByCycleWithDOCRequest, IvfCycleInseminationByCycleController, IvfCycleInseminationByCycleRequest, TreatmentCycleStatusController, TreatmentCycleStatusRequest } from '../../../../models/actor/actor';
import { AppData } from '../../../../models/appdata';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
//import { NgbdUploadActorImageModal } from '../../../../../modals/uploadactorimage/ngbuploadactorimage.modal';
import { ActorPersonalInfoController, ActorPersonalDetailInfoRequest, ActorPersonalDetailInfoController } from '../../../../models/profileinfo/profileinfo.model';
import { AppFeaturesList } from '../../../../constants/constants';
//import  './profilesteps.js';
import { HCPService } from '../../../../services/hcp.service';
declare var mess1: any;
declare var stepObject: any;
declare var pSteps: any;
declare var webGlObject: any;

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { routerTransition } from '../../../../animations/router.animations';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { NgbTcDetailsModal } from './tcdetails.modal';
import { NgbEventAddModal } from './eventadd.modal';
import { FdActorReportsDocController, FDActorDocRequest } from '../../../../../../../src/app/ncs/models/formdesign/fd.model';
import { FDService } from '../../../../../../../src/app/ncs/services/fd.service';
import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';
import { NgbInseminationEditModal } from './inseminationedit.modal';

@Component({
  selector: 'insemination2',
  templateUrl: './insemination2.component.html',
  styleUrls: ['./insemination2.component.scss'],
  animations: [routerTransition()]
})

export class Insemination2Component implements OnInit {
    @Output() GoFollicle: EventEmitter<any> = new EventEmitter();
  //Variable Declaration
  currentPage: string = "About"
  public isRequesting: boolean = false;
  CurrentActorProfileRequest: ActorProfileRequest;
  CurrentActorProfileController: ActorProfileController;
  //CurrentFdActorReportsDocController: FdActorReportsDocController[];
  //CurrentFDActorDocRequest: FDActorDocRequest;
  public ApiResData: ApiResponseModel;

  ValueChangeActorPersonalInfoController: ActorPersonalInfoController;
  ValueChangeActorImageController: ActorImageController;

  @Input() NurseActorCode: number = 0;
  @Input() ActorCode: number;
  
  @Input() CycleCode: number;
  @Input() Duration: number;
  @Input() FormattedCode: number;
    @Input() DisplayName: string;
    @Input() GradingModel: string;
  searchTitle: string;
  //
  //public FormattedCode: number = 0;
  public IsSetAccessRights: boolean;
  public CanEditProfileInfo: number = 0;
  public CanEditContactInfo: number = 0;
  public CanShowProfileInfo: number = 0;
  public CanShowContactInfo: number = 0;
  public Code: string;

  public CanShowProfileSummary: number = 0;
  public CanEditProfileSummary: number = 0;

  public CanShowJobPreferences: number = 0;
  public CanEditJobPreferences: number = 0;

  public CanShowEducation: number = 0;
  public CanEditEducation: number = 0;

  public CanShowEmploymentHistory: number = 0;
  public CanEditEmploymentHistory: number = 0;

  public CanShowReferences: number = 0;
  public CanEditReferences: number = 0;

  public CanShowIdentities: number = 0;
  public CanEditIdentities: number = 0;

  public CanShowCertifications: number = 0;
  public CanEditCertifications: number = 0;

  public CanShowMedicalFitness: number = 0;
  public CanEditMedicalFitness: number = 0;

  public CanShowProfileImage: number = 0;
  public CanEditProfileImage: number = 0;

  public CanShowLegalinfo: number = 0;
  public CanEditLegalinfo: number = 0;
  public showprofile: boolean = true;
  public showmessages: boolean = false;
  public LMPDate: Date;
  //

    CurrentSingleWellInseminationByCycleController: SingleWellInseminationByCycleController[];
    CurrentSingleWellInseminationByCycleRequest: SingleWellInseminationByCycleRequest;
    LoadInsemination() {
        this.CurrentSingleWellInseminationByCycleRequest = new SingleWellInseminationByCycleRequest();
        this.CurrentSingleWellInseminationByCycleRequest.TreatmentCycle = this.CycleCode;
        this.CurrentSingleWellInseminationByCycleRequest.ConditionalOperator = 10;
        this.CurrentSingleWellInseminationByCycleRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetSingleWellInseminationByCycleController();
    }
    GetSingleWellInseminationByCycleController() {
        this.StartRefreshing();


        this.actorservice.GetSingleWellInseminationByCycleController(this.CurrentSingleWellInseminationByCycleRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentSingleWellInseminationByCycleController = this.ApiResData.Result;
                    //this.length = this.CurrentSingleWellInseminationByCycleController.length;
                    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    this.stopRefreshing();
                    this.LoadInsemination2();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentIvfCycleInseminationLogByCycleWithDOCController: IvfCycleInseminationLogByCycleWithDOCController[];
    InseminationEndInfo: IvfCycleInseminationLogByCycleWithDOCController;
    CurrentIvfCycleInseminationLogByCycleWithDOCRequest: IvfCycleInseminationLogByCycleWithDOCRequest;
    LoadInsemination2() {
        this.CurrentIvfCycleInseminationLogByCycleWithDOCRequest = new IvfCycleInseminationLogByCycleWithDOCRequest();
        this.CurrentIvfCycleInseminationLogByCycleWithDOCRequest.TreatmentCycle = this.CycleCode;
        this.CurrentIvfCycleInseminationLogByCycleWithDOCRequest.DOC = 1;
        this.CurrentIvfCycleInseminationLogByCycleWithDOCRequest.ConditionalOperator = 10;
        this.CurrentIvfCycleInseminationLogByCycleWithDOCRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetIvfCycleInseminationLogByCycleWithDOCController();
    }
    GetIvfCycleInseminationLogByCycleWithDOCController() {
        this.StartRefreshing();


        this.actorservice.GetIvfCycleInseminationLogByCycleWithDOCController(this.CurrentIvfCycleInseminationLogByCycleWithDOCRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentIvfCycleInseminationLogByCycleWithDOCController = this.ApiResData.Result;
                    this.InseminationEndInfo = this.CurrentIvfCycleInseminationLogByCycleWithDOCController[0];
                    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    this.stopRefreshing();
                    this.LoadPatients();
                    this.LoadInseminationDatacycle();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

  CurrentTreatmentCyclesByActorCodeController: TreatmentCyclesByActorCodeController[];
  SelectedTreatmentCycle: TreatmentCyclesByActorCodeController;

  CurrentTreatmentCyclesByActorCodeRequest: TreatmentCyclesByActorCodeRequest;
  LoadPatients() {
    //alert("pickup");
    this.CurrentTreatmentCyclesByActorCodeRequest = new TreatmentCyclesByActorCodeRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentTreatmentCyclesByActorCodeRequest.Branch = 0;
    this.CurrentTreatmentCyclesByActorCodeRequest.ActorCode = this.ActorCode;
    this.CurrentTreatmentCyclesByActorCodeRequest.ConditionalOperator = 10;
    this.CurrentTreatmentCyclesByActorCodeRequest.FromDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.ToDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.CycleCode = this.CycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentTreatmentCyclesByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetTreatmentCyclesByActorCodeController();
  }

  GetTreatmentCyclesByActorCodeController() {
    this.StartRefreshing();


    this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentTreatmentCyclesByActorCodeController = this.ApiResData.Result;
          //this.ReceipientActorCode = this.CurrentTreatmentCyclesByActorCodeController[0].EggActorCode;
          this.SelectedTreatmentCycle = this.CurrentTreatmentCyclesByActorCodeController[0];
          this.LMPDate = this.SelectedTreatmentCycle.LMP;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          //this.LoadMasterReq();
          //this.LoadPlan();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
    CurrentIvfCycleInseminationByCycleController: IvfCycleInseminationByCycleController[];
    CurrentIvfCycleInseminationByCycleRequest: IvfCycleInseminationByCycleRequest;

    LoadInseminationDatacycle() {
        //alert("ScansData")
        this.CurrentIvfCycleInseminationByCycleRequest = new IvfCycleInseminationByCycleRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentIvfCycleInseminationByCycleRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetIvfCycleInseminationByCycleController();
    }

    GetIvfCycleInseminationByCycleController() {
        // this.StartRefreshing();

        this.CurrentIvfCycleInseminationByCycleRequest.CycleCode = this.CycleCode;

        //alert(this.FormattedCode);
        this.actorservice.GetIvfCycleInseminationByCycleController(this.CurrentIvfCycleInseminationByCycleRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentIvfCycleInseminationByCycleController = this.ApiResData.Result;


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
 
  constructor(private router: Router, public printService: PrintService,
    private route: ActivatedRoute, private loaderService: SpinnerService, private actorservice: ActorService, private hcpservice: HCPService, private fdservice: FDService, private tosterservice: NGXToastrService,
    private modalService: NgbModal) {

    //stepObject.init();
    //webGlObject.init();
  }


  ngOnInit() {
      this.LoadInsemination();
      this.LoadCycles();
    $.getScript('./healins-assets/js/jquery.steps.js');
    $.getScript('./healins-assets/js/profilesteps.js');
   
   
    //this.LoadPatients();
    ///this.LoadClinics();
    //this.LoadMessages();
   
  

    //alert(this.ActorCode);

   
    // Horizontal Timeline js for user timeline
    //$.getScript('./assets/js/vertical-timeline.js');
    //



  }
  
    CurrentTreatmentCycleStatusController: TreatmentCycleStatusController[];
    InseminationData: TreatmentCycleStatusController[];
    InseminationData2: TreatmentCycleStatusController;
    CurrentTreatmentCycleStatusRequest: TreatmentCycleStatusRequest;
    LoadCycles() {
        this.CurrentTreatmentCycleStatusRequest = new TreatmentCycleStatusRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
        this.CurrentTreatmentCycleStatusRequest.TreatmentCycleCode = this.CycleCode;
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;

        //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        this.CurrentTreatmentCycleStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
        this.GetTreatmentCycleStatusController();
    }

    GetTreatmentCycleStatusController() {
        //this.StartRefreshing();
        //this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date();
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();

        this.actorservice.GetTreatmentCycleStatusController(this.CurrentTreatmentCycleStatusRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentTreatmentCycleStatusController = this.ApiResData.Result;
                    this.InseminationData = this.ApiResData.Result;
                    var Inseminationlist = this.InseminationData.filter(
                        function (g) {
                            return g.PhaseActivity == "Insemination";
                        });
                    this.InseminationData = Inseminationlist;
                    this.InseminationData2 = this.InseminationData[0];
                    // alert(this.SemanAnalysis2.ActivityStatus);
                    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    //this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
  

  

 
  
  //
 
  //

  
 



  
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
 
  closeResult: string;
  // This function is used in open
 
  // Open content with dark section
  //openContent() {
  //  alert('open dialog');
  //  if (this.CurrentActorProfileController.ActorImageCode != null && this.CurrentActorProfileController.ActorImageCode > 0) {
  //    const modalRef = this.modalService.open(NgbdUploadActorImageModal, {
  //      centered: true
  //    })
  //    modalRef.componentInstance.ActorImageCode = this.CurrentActorProfileController.ActorImageCode;
  //    modalRef.componentInstance.ActorCode = this.CurrentActorProfileController.ActorCode;
  //    modalRef.componentInstance.ActorImageFile == this.CurrentActorProfileController.ActorImageFile;
  //    modalRef.componentInstance.ActorImageFileExtension = this.CurrentActorProfileController.ActorImageFileExtension;

  //    modalRef.result.then(x => { this.GetActorProfileController() })
      
  //  }
  //  else {
  //    alertFunctions.AlertParam('you dont have Permission to Upload...!');
  //  }
  //}
    Editinsemination() {
        const modalRef = this.modalService.open(NgbInseminationEditModal,
            {
              centered: true,
              size: "lg",
                keyboard: false,
                backdrop: 'static'

            })

        modalRef.componentInstance.CycleCode = this.CycleCode; /*this.GetCycleCode(s.FollicularGrowth)[0].TreatmentCycle*/
        //modalRef.componentInstance.FollicularGrowthCode = s.FollicularGrowth;
        //modalRef.componentInstance.ActivityCode = s.CycleActivity;
        modalRef.componentInstance.PatientCode = this.SelectedTreatmentCycle.EggPatientRegistrationNo;
        modalRef.componentInstance.Eggsourcetype = this.SelectedTreatmentCycle.EggSourceType;
        modalRef.componentInstance.ActorCode = this.ActorCode;
        //modalRef.componentInstance.OocyteQualityCode = this.OqaDetailsData.OocyteQualityCode;
        //modalRef.componentInstance.DOC = s.DOC;
        modalRef.componentInstance.GradingModel = this.GradingModel;
        modalRef.result.then((val: string) => {
            //alert(val);
            if (val == "Load") {
                this.LoadInsemination();
                this.LoadCycles();
                this.GoFollicle.emit();
            }

        });

    }

    Top() {
        let m = document.querySelector("#top");
        if (m) {
            m.scrollIntoView({ block: "center", inline: "nearest" });
        }
    }
    Bottom() {
        let m = document.querySelector("#bottom");
        if (m) {
            m.scrollIntoView({ block: "center", inline: "nearest" });
        }
    }
  printinsemi() {
    this.printService.printDocument("inseminationlog",
      {
        Owner: this.SelectedTreatmentCycle.OwnerName, Gender: this.SelectedTreatmentCycle.OwnerGender, Age: this.SelectedTreatmentCycle.OwnerAgeYears, PatientId: this.SelectedTreatmentCycle.OwnerFormattedCode, Infertility: this.SelectedTreatmentCycle.InfertilityType, CycleNo: this.SelectedTreatmentCycle.CycleNo, CycleType: this.SelectedTreatmentCycle.CycleType, Protocol: this.SelectedTreatmentCycle.ProtocolName,
        TreatmentCycleCodedata: this.SelectedTreatmentCycle.Code, ActorCodedata: this.SelectedTreatmentCycle.EggActorCode, ProtocolStart: this.SelectedTreatmentCycle.ProtocolStartDate, ProtocolEnd: this.SelectedTreatmentCycle.ProtocolEndDate,
        InsemDate: this.InseminationEndInfo.InseminationDate, InsemTime: this.InseminationEndInfo.InseminationTime, NtimesInf: this.InseminationEndInfo.NtimesInformed, ProcessedBy: this.InseminationEndInfo.ProcessedByName, Doctor: this.InseminationEndInfo.DoctorName, Details: this.InseminationEndInfo.IterationType, Nurse: this.InseminationEndInfo.NurseName,

      }
    );
  }

  printinsemidroplet() {
    this.printService.printDocument2(this.SelectedTreatmentCycle.OwnerFormattedCode, 0

    );
    this.printService.printDocument("inseminationlogdroplet",
      {
        Owner: this.SelectedTreatmentCycle.OwnerName, Gender: this.SelectedTreatmentCycle.OwnerGender, Age: this.SelectedTreatmentCycle.OwnerAgeYears, PatientId: this.SelectedTreatmentCycle.OwnerFormattedCode, Infertility: this.SelectedTreatmentCycle.InfertilityType, CycleNo: this.SelectedTreatmentCycle.CycleNo, CycleType: this.SelectedTreatmentCycle.CycleType, Protocol: this.SelectedTreatmentCycle.ProtocolName,
        TreatmentCycleCodedata: this.SelectedTreatmentCycle.Code, ActorCodedata: this.SelectedTreatmentCycle.EggActorCode, ProtocolStart: this.SelectedTreatmentCycle.ProtocolStartDate, ProtocolEnd: this.SelectedTreatmentCycle.ProtocolEndDate,
        EggSourceData: this.SelectedTreatmentCycle.EggSourceType, DonorData: this.SelectedTreatmentCycle.EggName, DonorCode: this.SelectedTreatmentCycle.EggFormattedCode, InsemDate: this.InseminationEndInfo.InseminationDate, InsemTime: this.InseminationEndInfo.InseminationTime, NtimesInf: this.InseminationEndInfo.NtimesInformed, ProcessedBy: this.InseminationEndInfo.ProcessedByName, Doctor: this.InseminationEndInfo.DoctorName, Details: this.InseminationEndInfo.IterationType, Nurse: this.InseminationEndInfo.NurseName,

      }
    );
  }

}
